import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { UserManagementComponent } from "./user-management/user-management.component";
import { ViewUserComponent } from "./view-user/view-user.component";
import { AddUserComponent } from "./add-user/add-user.component";
import { PermissionGuard } from "../../guards/permisson.guard";
import { UserDashboardComponent } from "./user-dashboard/user-dashboard.component";
import { UserlistComponent } from "./userlist/userlist.component";
import { ViewUserPickDropOrder } from "./view-user-pickdrop-order/view-user-pickdrop-order.component";

const routes: Routes = [
  {
    path: "",
    component: UserManagementComponent,
    children: [
      { path: "", redirectTo: "/main/user-management/list", pathMatch: "full" },
      { path: "view-user", component: ViewUserComponent },
      { path: "list", component: UserlistComponent },
      { path: "view-user-pick-and-drop-order", component: ViewUserPickDropOrder },
      {
        path: "add-user",
        canActivate: [PermissionGuard],
        data: { access: "users", level: "W" },
        component: AddUserComponent,
      },
      
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserManagementRoutingModule {}
